import AppFlex from './AppFlex'

export default AppFlex